import { Component, EventEmitter, Input, OnInit, SimpleChanges, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { BehaviorSubject, Observable } from 'rxjs';

import { DealerActions } from 'src/app/common/store/actions/dealer.actions';
import { FilesActions } from 'src/app/common/store/actions/files.actions';

import { DateRange, MatCalendar, MatCalendarCellClassFunction, MatCalendarCellCssClasses } from '@angular/material/datepicker';

import { BuyActions } from 'src/app/common/store/actions/buy.actions';
import { ProviderOfferDialogComponent } from '../provider-offer-dialog/provider-offer-dialog.component';
import { selectAllCarImagesFolders, selectProviderOffer } from 'src/app/common/store/state/app.state';
import { CdkOverlayOrigin } from '@angular/cdk/overlay';

import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { Dealer } from 'src/app/public/account/models/dealer.model';
import { ProposalStatus } from 'src/app/public/buy/constants/buy-basic-data';
import { ProposalDialogComponent } from 'src/app/public/buy/elements/proposal-dialog/proposal-dialog.component';
import { NumberDialogComponent } from 'src/app/public/common/components/number-dialog/number-dialog.component';
import { SelectDialogComponent } from 'src/app/public/common/components/select-dialog/select-dialog.component';
import { TableDialogComponent } from 'src/app/public/common/components/table-dialog/table-dialog.component';
import { AppFunctions } from 'src/app/public/common/constants/app-functions';
import { AppointmentStatus } from 'src/app/public/common/constants/common-basic-data';
import { ObjectSource, Currency } from 'src/app/public/common/constants/general-basic-data';
import { FileData } from 'src/app/public/common/models/file-data.model';
import { ObjectData } from 'src/app/public/common/models/object-data.model';
import { Price } from 'src/app/public/common/models/string-data.model';
import { BookingStatus } from 'src/app/public/rent/constants/rent-basic-data';
import { BookingDialogComponent } from 'src/app/public/rent/elements/booking-dialog/booking-dialog.component';
import { CarBusinessLine, CarBasicData } from '../../constants/car-basic-data';
import { Car } from '../../models/car.model';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatExpansionModule } from '@angular/material/expansion';
import { AppointmentsComponent } from 'src/app/public/common/elements/appointments/appointments.component';
import { BookingsComponent } from 'src/app/public/rent/elements/bookings/bookings.component';
import { ConversationsComponent } from 'src/app/public/common/elements/conversations/conversations.component';
import { JobsComponent } from 'src/app/public/keep/elements/jobs/jobs.component';
import { ProposalsComponent } from 'src/app/public/buy/elements/proposals/proposals.component';
import { BookingEditComponent } from 'src/app/public/rent/elements/booking-edit/booking-edit.component';
import { FormsModule } from '@angular/forms';


@Component({
    selector: 'app-provider-offer-card-seller',
    templateUrl: './provider-offer-card-seller.component.html',
    styleUrls: ['./provider-offer-card-seller.component.css'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [FormsModule, MatProgressSpinnerModule, MatSlideToggleModule, MatExpansionModule, MatIconModule, MatDividerModule, AppointmentsComponent, BookingsComponent, ConversationsComponent, JobsComponent, MatCalendar, CdkOverlayOrigin, ProposalsComponent, BookingEditComponent]
})
export class ProviderOfferCardSellerComponent implements OnInit {
  
  @Input() offer: Car = new Car()
  @Input() carImagesFolder: FileData[] = [];
  @Input() currentDealer: Dealer = new Dealer();

  @Input() objectSource: ObjectSource = ObjectSource.BUY
  //@Input() businessLine: CarBusinessLine = CarBusinessLine.BUY;
  //@Input() offerId: string = "";
  //@Input() carId: string = "";

  carImagesFolders$: Observable<Map<string, Array<FileData>>>;

  currentImageIndex: number = 0;

  currentImageIndexSubject:BehaviorSubject<number>;
  currentProviderActiveStatus$:BehaviorSubject<boolean>;

  currentImage: any;
  
  fetchingImage: boolean = false;

  providerActive = true;

  showBookingAddNew: boolean = false;
  showBookingCalendar: boolean = false;

  todayDate: Date;
  tomorrowDate: Date;
  yesterdayDate: Date;

  selectedDateRange: DateRange<Date>;

  ProposalStatus = ProposalStatus;
  AppointmentStatus = AppointmentStatus;

  newJobCarId = "";
  newJobCount = 0;

  newAppointmentCarId = "";
  newAppointmentCount = 0;

  CarBusinessLine = CarBusinessLine

  constructor(
    private router: Router,
    private store: Store, 
    private readonly sanitizer: DomSanitizer,
    public dialog: MatDialog) {

      this.currentImageIndexSubject = new BehaviorSubject<number>(0);

      this.currentProviderActiveStatus$ = new BehaviorSubject<boolean>(this.offer.providerActive);

      this.todayDate = new Date();
      this.tomorrowDate = new Date(this.todayDate);
      this.yesterdayDate = new Date(this.todayDate);

      this.tomorrowDate.setDate(this.tomorrowDate.getDate()+1);
      this.yesterdayDate.setDate(this.yesterdayDate.getDate()-1);

      this.selectedDateRange = new DateRange<Date>(this.todayDate, this.tomorrowDate);

      this.carImagesFolders$ = store.select(selectAllCarImagesFolders);
    }

  ngOnInit(): void {

    this.currentImageIndexSubject.subscribe(
      (i: number) =>  {
        this.currentImage = this.getCarImage(i);
      }
    );
    this.currentImage = this.getCarImage(0);

    this.currentProviderActiveStatus$.subscribe(
      (status: boolean) =>  {
        this.providerActive = status;
      }
    );

    this.carImagesFolders$.subscribe(
      (res: Map<string, Array<FileData>>) =>  {
        this.carImagesFolder = res.get(this.offer.carId)!;
      }
    );
  }

  ngOnChanges(changes: SimpleChanges): void {
    
    const latestImagesFolder = changes['carImagesFolder'];
    if (latestImagesFolder != undefined) {
      if ((latestImagesFolder.currentValue?.length as number) === 1) {
        
        this.currentImageIndexSubject.next(0);
      }
    }

    const latestProviderActive = changes['car'];
    if (latestProviderActive != undefined) {

        this.currentProviderActiveStatus$.next(latestProviderActive.currentValue.providerActive as boolean)
      
    }
  }

  moneyFormat(s: string): string{
    return AppFunctions.numberWithSpaces(s);
  }

  dateFormat(dt: string): string{

    return AppFunctions.stringToDatetime(dt);
  }

  createImageFromBlob(imageData: Blob): any {
    let objectUrl = URL.createObjectURL(imageData);     
    return this.sanitizer.bypassSecurityTrustUrl(objectUrl);    
  }

  getCarImage(i: number): any{

    if(this.carImagesFolder != undefined && this.carImagesFolder.length > 0 ){
      let objectUrl = URL.createObjectURL(this.carImagesFolder[i].blob);     
      return this.sanitizer.bypassSecurityTrustUrl(objectUrl); 
    }
  }

  openPriceHistoryDialog(history: Price[], businessLine: CarBusinessLine): void {

    const dialogRef = this.dialog.open(TableDialogComponent, {
      data: {priceHistory: history, businessLine: businessLine, label: "Price"}
    });

    dialogRef.afterClosed().subscribe(() => {
  
    });
  }


  openOfferDialog(carId: string): void {
    let amount = 0;
    
    const dialogRef = this.dialog.open(NumberDialogComponent, {
      data: {amount: amount, label: "Offer"}
    });

    dialogRef.afterClosed().subscribe((result: number) => {
      console.log('New offer = '+result+ " car Id = "+carId);

      if(result > 0 )
        this.store.dispatch(DealerActions.createNewCarOfferSubmit( {carId: carId, amount: result }));
    });
  }

  
  openNewJobDialog(carId: string): void{

    console.log(carId)

    this.newJobCarId = carId;
    this.newJobCount++;

  }

  openNewAppointmentDialog(carId: string): void{

    this.newAppointmentCarId = carId;
    this.newAppointmentCount++;

  }
 
  openBookingDialog(bookingId: number): void {
  
    let objectData: ObjectData = new ObjectData(this.objectSource, this.offer.offerId, bookingId );

    const dialogRef = this.dialog.open(BookingDialogComponent, {
      data: objectData
    });
  }

  openProposalDialog(proposalId: number, isModification: boolean): void {
  
    let objectData: ObjectData = new ObjectData(this.objectSource, this.offer.offerId, proposalId );

    const dialogRef = this.dialog.open(ProposalDialogComponent, {
      data: objectData
    });

    if(isModification){
      let instance = dialogRef.componentInstance
      instance.isModification = isModification
    }
  }
  
  updateProposalStatus(proposalId: number, status: ProposalStatus){

    //console.log('heyy   '+status.toString());

    this.store.dispatch(BuyActions.proposalStatusUpdateSubmit ( { proposalId: proposalId, status: status, objectSource: this.objectSource }));

  }

  goToCarDetailsPage(carId: string): any{

    console.log("navigate to "+carId);
    this.router.navigate(
      ['/buy-car/details'],
      { queryParams: { id: carId} }
    );
  }

  goToSellerPage(sellerId: string): any{

    this.router.navigate(
      ['/buy-car/seller'],
      { queryParams: { id: sellerId } }
    );
  }

  goToCarEditPage(carId: string){

    this.router.navigate(
      ['/sell-car'],
      { queryParams: { id: carId} }
      );
  }

  deleteCar(carId: string){
     //this.store.dispatch(DealerActions.deleteCarSubmit( {carId: carId}));
  }

  openProviderOfferDialog(): void {

    // let offer: ProviderOffer = new ProviderOffer();
    // offer.businessLine = businessLine
    // offer.carId = carId
    // offer.country = this.currentDealer.countryResident
    //offer.country = 
    //console.log(offer);
 
    const dialogRef = this.dialog.open(ProviderOfferDialogComponent, {
      //data: Object.assign(new Car(), this.car)
      //data: structuredClone(this.car)
      data: structuredClone(this.offer)
    });

    dialogRef.afterClosed().subscribe((result: any) => {

      if(result != undefined ){
        console.log(result)
        
        if(result.id === ''){
          //this.store.dispatch(DealerActions.createNewCarSubmit({ car: result }));
        }
        else{
          //this.store.dispatch(DealerActions.updateCarSubmit({ carUpdates: result }));
        }
      }    
    });
  }

  openPriceDialog(carId: string, oldAmount: number, businessLine: CarBusinessLine): void {
    
    const dialogRef = this.dialog.open(NumberDialogComponent, {
      data: {amount: oldAmount, label: businessLine + " Price"}
    });

    dialogRef.afterClosed().subscribe((result: number) => {
      //console.log('New price = '+result+ " car Id = "+carId);
      //let newPrice: Price = new Price(businessLine, result, 0);
      
      if(result > 0 ){
        this.store.dispatch(DealerActions.createNewCarPriceSubmit( {carId: carId, businessLine: businessLine, price: new Price(result, Currency.XAF, 0) }));
      }
        
    });
  }

  nextImage(): void{
    console.log("current = "+this.currentImageIndex);

    if(this.currentImageIndex === this.carImagesFolder.length-1)
      this.currentImageIndex = 0;
    else 
      this.currentImageIndex++;
    console.log("next = "+this.currentImageIndex);
    this.currentImageIndexSubject.next(this.currentImageIndex);
  }

  prevImage(): void{
    console.log("current ="+this.currentImageIndex);
    if(this.currentImageIndex === 0 )
      this.currentImageIndex = this.carImagesFolder.length-1;
    else 
      this.currentImageIndex--;
    
    console.log("prev ="+this.currentImageIndex);
    this.currentImageIndexSubject.next(this.currentImageIndex);
  }

  uploadImage(carId: string, event: any, ): void {

    let files: File[] = event.target.files;
    console.log('file name = '+files[0].name);

    if(files != undefined && files.length > 0){
      this.store.dispatch(FilesActions.uploadCarImageSubmit({ carId: carId, file: files[0] }));
    }
  }

  selectImage(index: number): void{
    this.currentImageIndex = index;
    this.currentImageIndexSubject.next(this.currentImageIndex);
  }

  updateProviderOfferStatus(offerId: string, status: boolean){
    //this.store.dispatch(DealerActions.updateCarStatusSubmit( {carId: carId, status: this.getCarStatusNext(status) }));
  }

  toggleProviderOfferPosted(carId: string, offerId: string, businessLine: CarBusinessLine){
    console.log(offerId + "  "+ businessLine)
    this.store.dispatch(DealerActions.providerOfferTogglePostedSubmit( { carId: carId, providerOfferId: offerId, businessLine: businessLine, objectSource: this.objectSource}));
  }

  toggleProviderOfferClosed(carId: string, offerId: string, businessLine: CarBusinessLine){
    console.log(offerId + "  "+ businessLine)
    this.store.dispatch(DealerActions.providerOfferToggleClosedSubmit( { carId: carId, providerOfferId: offerId, businessLine: businessLine, objectSource: this.objectSource}));
  }

  deleteOffer(carId: string, providerOfferId: string, businessLine: CarBusinessLine){
     this.store.dispatch(DealerActions.providerOfferDeleteSubmit( { carId: carId, providerOfferId: providerOfferId, businessLine: businessLine, objectSource: this.objectSource }));
    }

  getCarStatusNext(status: string): string{
    return CarBasicData.carStatuses[status].next;
  }

  updateBusinessLineStatus(carId: string, status: boolean, businessLine: CarBusinessLine){
    console.log('status 1 = '+status);
    this.store.dispatch(DealerActions.toggleCarBusinessLineStatusSubmit( {carId: carId, status: status, businessLine: businessLine }));
  }

  
  updateProviderActiveStatus(carId: string, status: boolean){
    console.log('status 1 = '+status);

    this.store.dispatch(DealerActions.updateCarProviderActiveSubmit( {carId: carId, providerActive: status }));
  }

  updateProvider(carId: string, providerId: string){
    console.log('status 1 = ');
    this.store.dispatch(DealerActions.updateCarProviderSubmit( {carId: carId, providerId: providerId }));
  }


  openProviderDialog(carId: string): void {
    
    const dialogRef = this.dialog.open(SelectDialogComponent, {
      data: {options: this.currentDealer.favoriteProviderIds, label: "Nouveau provider"}
    });

    dialogRef.afterClosed().subscribe((result: string) => {
      console.log('New provider = '+result+ " car Id = "+carId);
      //let newPrice: Price = new Price(businessLine, result, 0);
      
      if(result != undefined){
        this.store.dispatch(DealerActions.updateCarProviderSubmit( {carId: carId, providerId: result }));
      }
        
    });
  }

  canNewProposal(): boolean{
    return false;
  }

  canNewBooking(): boolean{
    let index = this.offer.myBookings.findIndex(p => p.status !== BookingStatus.CANCELLED)
    return index === -1;
  }

  canNewConversation(): boolean{
    return false;
  }

  canNewAppointment(): boolean{
    return false;
  }

}
